export const config = {
    env: process.env.NEXT_PUBLIC_APP_ENV,
    apiUrl: process.env.NEXT_PUBLIC_API_URL,
    redirectSuccessUrl: `${process.env.NEXT_PUBLIC_APP_URL}/success`,
    redirectCancelUrl: `${process.env.NEXT_PUBLIC_APP_URL}/cancel`,
};
